/* Da Luca V3.48 — cart drawer add/remove AOV module. */
(function () {
  'use strict';
  if (window.DaLucaCartAOVV348) return;
  window.DaLucaCartAOVV348 = true;

  function route(name, fallback) {
    return (window.theme && window.theme.routes && window.theme.routes[name]) || fallback;
  }

  async function readJson(response, fallback) {
    var data = null;
    try { data = await response.json(); } catch (e) {}
    if (!response.ok || (data && data.status && Number(data.status) >= 400)) {
      throw new Error((data && (data.description || data.message)) || fallback || 'Unable to update cart.');
    }
    return data;
  }

  async function getCart() {
    return readJson(await fetch(route('cart_url','/cart') + '.js', {
      method: 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }), 'Unable to read cart.');
  }

  function findItem(cart, variantId) {
    return (cart && cart.items || []).find(function (item) {
      return String(item.variant_id || item.id) === String(variantId);
    }) || null;
  }

  async function addOne(variantId) {
    return readJson(await fetch(route('cart_add_url','/cart/add.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: { '_DaLuca care item': 'true' } }] })
    }), 'Unable to add this item.');
  }

  async function removeOne(item) {
    if (!item) return;
    var nextQty = Math.max(0, Number(item.quantity || 1) - 1);
    return readJson(await fetch(route('cart_change_url','/cart/change.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: item.key || item.id, quantity: nextQty })
    }), 'Unable to remove this item.');
  }

  function setBusy(button, busy, selected) {
    button.disabled = !!busy;
    button.classList.toggle('is-busy', !!busy);
    button.classList.toggle('is-selected', !!selected);
    button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    window.DaLucaI18n.setText(button, busy ? (selected ? 'Removing…' : 'Adding…') : (selected ? 'Remove' : 'Add +'));
    var card = button.closest('[data-dl-cart-aov-card]');
    if (card) card.classList.toggle('is-selected', !!selected);
  }

  function status(button, message) {
    var root = button.closest('[data-dl-cart-aov]');
    var node = root && root.querySelector('[data-dl-cart-aov-status]');
    if (node) window.DaLucaI18n.setText(node, message || '');
  }

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-dl-cart-aov-toggle]');
    if (!button || button.disabled || button.closest('.daluca-pdp--apple-standard[data-daluca-apple-care-bound="true"] .daluca-apple-care')) return;
    var variantId = String(button.getAttribute('data-variant-id') || '').trim();
    if (!variantId) return;

    event.preventDefault();
    event.stopPropagation();

    var selected = button.getAttribute('aria-pressed') === 'true';
    var inCartDrawer = !!button.closest('#Cart-Drawer');
    var removing = selected && !inCartDrawer;
    setBusy(button, true, selected);
    status(button, '');

    try {
      var cart = await getCart();
      var item = findItem(cart, variantId);
      if (removing && item) await removeOne(item);
      else if (!removing && !item) await addOne(variantId);
      cart = await getCart();
      var remaining = findItem(cart, variantId);
      var card = button.closest('[data-dl-cart-aov-card]');
      if (card) card.hidden = inCartDrawer && !!remaining;
      setBusy(button, false, !inCartDrawer && !!remaining);
      status(button, removing ? 'Removed one from your cart.' : (item ? 'Already in your cart.' : 'Added to your cart.'));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
    } catch (error) {
      setBusy(button, false, selected);
      status(button, (error && error.message) || 'Unable to update cart.');
    }
  }, true);
})();


(function () {
  'use strict';
  const handles=new Set(['venetian-cream-3oz','venetian-cream-4oz','venetian-cream-leather-shine-cloth','extra-standard-spring-bars','spring-bar-buckle-removal-tool','spring-bar-tool']);
  const oldKeys=new Set(['For','For strap','_DaLuca accessory add-on','_DaLuca accessory for','_DaLuca custom add-on','_DaLuca add-on for','_DaLuca cart add-on','_DaLuca strap add-on','_DaLuca OOAK add-on for']);
  let running=false,timer=0;
  const base=String(window.Shopify?.routes?.root || '/').replace(/\/?$/,'/');
  async function request(path,body){
    const response=await fetch(base+path,{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:{'Content-Type':'application/json',Accept:'application/json'},...(body?{body:JSON.stringify(body)}:{})});
    const data=await response.json();
    if(!response.ok||Number(data.status)>=400)throw new Error(data.description||'Unable to update care items');
    return data;
  }
  function needsNormalization(item){
    if(!handles.has(item.handle)||item.selling_plan_allocation)return false;
    const props=item.properties||{};
    if(props['_DaLuca linked upgrade']||Object.keys(props).some(key=>/^_gpo|^_dl_/.test(key)))return false;
    return props['_DaLuca care item']!=='true'||Object.keys(props).some(key=>oldKeys.has(key));
  }
  async function normalize(){
    if(running)return;
    running=true;let changed=false;
    try{
      let cart=await request('cart.js');
      for(let i=0;i<30;i++){
        const item=cart.items.find(needsNormalization);
        if(!item)break;
        const properties={};
        Object.entries(item.properties||{}).forEach(([key,value])=>{if(!oldKeys.has(key))properties[key]=value;});
        properties['_DaLuca care item']='true';
        cart=await request('cart/change.js',{id:item.key,quantity:item.quantity,properties});changed=true;
      }
      if(changed)document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart,source:'daluca-care-normalized'}}));
    }catch(error){console.warn('[DaLuca care cart]',error.message);}
    finally{running=false;}
  }
  function queue(event){if(event?.detail?.source==='daluca-care-normalized'||running)return;clearTimeout(timer);timer=setTimeout(normalize,180);}
  ['cart:item-added','cart:refresh','line-item:change:end'].forEach(name=>document.addEventListener(name,queue));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',queue,{once:true});else queue();
})();


